import React from "react";
import { AddButtonStyles } from "./AddButtonStyles";
import AddIcon from "@mui/icons-material/Add";

const AddButton = ({ onClick, ButtonText, disabled }) => {
  return (
    <AddButtonStyles onClick={onClick} disabled={disabled}>
        <AddIcon />
        {ButtonText}
    </AddButtonStyles>
  );
};

export default AddButton;
